import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InsuranceService } from 'app/modules/insurance/insurance.service';
import { CommonService } from 'app/services/common.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-partnership-listing',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './partnership-listing.component.html',
})
export class PartnershipListingComponent {
    @Input() selectedLanguage: string;
    @Input() partnershipImgUrls: any;
    activeFinancingType: 'financing' | 'beyondFinancing' = 'financing';
    bankProductsList = [];
    p2pProductsList = [];
    techServicesList = [];
    insuranceImages = {};
    insuranceList: any[] = [];

    constructor(
        private fiAgencyService: CommonService,
        private insuranceService: InsuranceService,
        private toastr: ToastrService,
    ) {}

    ngOnInit() {
        this.getProductData();
        this.getInsuranceData();
    }

    toggleFinancingType(button: 'financing' | 'beyondFinancing') {
        this.activeFinancingType = button;
    }

    getProductData() {
        this.fiAgencyService.getAgencyData().subscribe({
            next: (data) => {
                this.bankProductsList = data.banks;
                this.p2pProductsList = data.p2p;
                this.techServicesList = data.technologyServicesPartner;
            },
            error: (err) => {
                this.toastr.error(err.error.message);
            },
        });
    }

    getInsuranceData() {
        this.insuranceService.getInsuranceData().subscribe({
            next: (res) => {
                this.insuranceList = res?.Policystreet?.slice(0, 1) || [];
            },
            error: (err) => {
                this.toastr.error(err.error.message);
            },
        });
    }

    getImgUrl(img: string): string {
        if (img) {
            return img;
        }
        return this.selectedLanguage === 'bm'
            ? '/assets/images/image_not_available_bm.webp'
            : '/assets/images/image_not_available_en.webp';
    }
}
